import { Show } from '@hover/blueprint/chakra';
import type { ReactNode } from 'react';
import React from 'react';

export const SkipSSR = ({ children }: { children: ReactNode }) => (
  <Show ssr>{children}</Show>
);
